<template>
	<div class="storehome">
		<StoreList />
		<div class="home-box">
			<div class="klnf">{{$t('other.a1885')}} </div>
			<div class="home-box-ttp">
				<div class="skilk" v-for="(item,index) in integralData" :key="index ">
					<div style="font-size:20px">{{item.value}} </div>
					<div class="lknl">{{item.desc}}</div>
				</div>
			</div>
		</div>
        <PointDetails />
		
		<SellerList />
       
	
	</div>
	
</template>

<script>
import PointDetails from './pointDetails'
import SellerList from './sellerList'
import StoreList from './storeList'

import deductionApi from '../../api/moudles/deduction'
import userstoreItmeApi from '../../api/moudles/userStoreItems'
import newOrdersApi from '../../api/moudles/newOrders'
import processedApi from '../../api/moudles/processed.js'
import utils from '@/utils/utils' 
import { resolve } from 'path'
import { promises } from 'fs'

	export default{
		data(){
			return {
				integralData:[{
					desc:this.$t('other.a1886'),
					value:0
				},{
					desc:this.$t('other.a1887'),
					value:0
				},{
					desc:this.$t('other.a1888'),
					value:0
				},],
				getDataParams:{},
				userInfo:JSON.parse(localStorage.getItem('userInfo')),
				logparams:{}
				
				
			}
		},
		
		
	
		components:{
			PointDetails,
			SellerList,
			StoreList
		},
		created(){
			this.getDataParams.end=null
			this.getDataParams.start=null
			this.getDataParams.hasStoreItem=true
			this.getDataParams.hasPdf=true
			this.getDataParams.offset=null
			this.getDataParams.page=0
			this.getDataParams.orderId=null
			this.getDataParams.logistics=null
			this.getDataParams.packageTime=null
			this.getDataParams.platform=null
			this.getDataParams.sellerUserId=null
			this.getDataParams.shopIds=this.userInfo.shopIds
			this.getDataParams.storeIds=this.userInfo.storeIds
			this.getDataParams.sortType=0
			this.getDataParams.userId=this.userInfo.userId
			// this.getUnprocessOrder()
			// this.getPackAgeOrders()

			this.logparams.userId=this.userId
			this.logparams.orderId=null
			this.logparams.shopIds=null
			this.logparams.storeIds=this.userInfo.storeIds
			this.logparams.end=utils.getRecentSevenDay(1)
			this.logparams.start=utils.getRecentSevenDay(0)
			this.logparams.userId=this.userInfo.userId
			
			this.init()
		},
		methods:{
			init(){
				let promise1=this.getUnprocessOrder()
				let promise2=this.getPackAgeOrders()
				let that=this
				Promise.all([promise1, promise2]).then(function(values) {
				that.integralData=[]
				that.integralData.push(values[0],...values[1])
				that.getPointLog()
				console.log('values',values)
				console.log('integralData',that.integralData)
				})
			},

			getPointLog(){
				deductionApi
				.getIntegralLog(this.logparams)
				.then(res => {
					if(res.code === 200) {
						console.log('收入支出',res.data.logs)
						this.integralData[2].value=res.data.feeCount.toFixed(2)

					}else{
						this.$message.warning(res.msg)
					}
				})
			},

			//获取订单处理订单数量
			getUnprocessOrder(){
				return new Promise((resolve) => {
					newOrdersApi
					.queryPendingOrders(this.getDataParams)
					.then(res => {
					if(res.code === 200 ){
					console.log('desc',res.data)
						resolve({
							desc:this.$t('other.a1886'),
							value:res.data.length
						})
					}else{
					this.$message.warning(res.msg)
					}
					})
				})
			},

			//获取已处理订单
			getPackAgeOrders(){
				return new Promise((resolve) => {
					processedApi
					.getProcessedOrderBySeller({
						end: utils.getRecentDays(1),
						logistics: null,
						offset: 50,
						orderId: "",
						packageTime: null,
						page: 0,
						partnerId: null,
						platform: null,
						shopIds: this.userInfo.shopIds,
						start: utils.getRecentDays(0),
						storeIds: this.userInfo.storeIds,
						userId: this.userInfo.userId
					})
					.then(res => {
						if(res.code === 200) {
							console.log('已处理订单',res.data)
							
							resolve([{
								desc:this.$t('other.a1887'),
								value:res.data.length
							},{
								desc:this.$t('other.a1888'),
								value:0
							}])
						
						}else{
							this.$message.warning(res.msg)
						}
					})
				})
			},

		}



    

	}
		

	
	
	
</script>

<style lang="scss" scoped>

.storehome{
	background-color: #eee;
	padding-top: 20px;
	margin-top: -5px;

	.home-box-ttp{
		display: flex;
		justify-content: space-between;
		padding: 10px;
		margin-bottom: 30px;
		
	}

	.home-box{
		background-color: #fff;
		box-sizing: border-box;
		margin: 15px;
		border-radius: 5px;
	}

	.jlknkg{
		display: flex;
		justify-content: space-around;
		padding: 10px;
	}
	.ilnkg{
		background-color: #fff;
		margin: 0 15px 20px 15px;
		border-radius: 5px;
	}

	.klnf{
		font-weight: bold;
		color: #616066;
		margin-bottom: 30px;
		padding: 0px 10px;
		font-size: 25px;
		text-align: center;

	}

	.lknl{
		padding-top: 15px;
		color: #919099;
		font-size: 14px;
	}

	
	

	.skilk{
		flex: 1;
    	border-right: 2px dashed #ddd;
		padding: 20px;
		
	}


}

</style>
